import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { withTranslation } from "react-i18next";

function EditGroupDialog({ show, groupName, newName, onNewNameChange, onSave, onClose, loading, t }) {
    if (!show) return null;

    return (
        <Dialog
            title={t("group.edit_dialog_title")}
            onClose={onClose}
            width={400}
        >
            <div className="p-3">
                <label className="form-label">{t("group.edit_group_label")}</label>
                <input
                    type="text"
                    className="form-control mb-3"
                    value={newName}
                    onChange={(e) => onNewNameChange(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && onSave()}
                    disabled={loading}
                />
            </div>
            <DialogActionsBar layout="end" style={{ padding: "12px 16px" }}>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                    disabled={loading}
                >
                    {t("group.cancel_button")}
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onSave}
                    disabled={loading || !newName?.trim() || newName.trim() === groupName}
                >
                    {t("group.save_button")}
                </button>
            </DialogActionsBar>
        </Dialog>
    );
}

export default withTranslation("attribute/common")(EditGroupDialog);
